import FilesCard from "./FilesCard";

export default FilesCard;
